import get from "lodash.get";
import { IntxBuilder } from "./IntxBuilder";
import { VOLUME_SCENARIOS } from "../../constants/storageConstants";

export const getVcTableRows = (projectData) => {
  return projectData.intersections?.map(
    ({ laneConfig, type, uniqueName }, index) => {
      const getMaxVC = (scenario) => {
        var volumes = get(projectData.trafficVolumes, scenario);

        if (volumes === undefined) {
          return null;
        } else {
          return IntxBuilder.createCapacityEngine({
            type,
            name: uniqueName,
            volumes,
            globalParams: projectData.trafficVolumes.volumeAdjustmentFactors,
            orientation: projectData.projectInfo.majorFacility,
          })
            ?.computeVCAnalysisOnChanges?.({
              volumes,
              laneConfigInputs: laneConfig,
            })
            .maxVC.toFixed(2);
        }
      };

      const openingYearAmPeak = getMaxVC(VOLUME_SCENARIOS.OPENING_YEAR_AM_PEAK);
      const openingYearPmPeak = getMaxVC(VOLUME_SCENARIOS.OPENING_YEAR_PM_PEAK);
      const openingYearWeekendPeak = getMaxVC(
        VOLUME_SCENARIOS.OPENING_YEAR_WEEKEND_PEAK
      );
      const designYearAmPeak = getMaxVC(VOLUME_SCENARIOS.DESIGN_YEAR_AM_PEAK);
      const designYearPmPeak = getMaxVC(VOLUME_SCENARIOS.DESIGN_YEAR_PM_PEAK);
      const designYearWeekendPeak = getMaxVC(
        VOLUME_SCENARIOS.DESIGN_YEAR_WEEKEND_PEAK
      );
      return {
        id: index + 1,
        uniqueName,
        openingYearAmPeak,
        openingYearPmPeak,
        openingYearWeekendPeak,
        designYearAmPeak,
        designYearPmPeak,
        designYearWeekendPeak,
        maxVC: Math.max(
          openingYearAmPeak,
          openingYearPmPeak,
          openingYearWeekendPeak,
          designYearAmPeak,
          designYearPmPeak,
          designYearWeekendPeak
        ),
      };
    }
  );
};
